import React, { useEffect } from "react";
import useForm from "./index";
import { TForm, TInputProps } from "@/components/form/types";

type THiddenInput = any;
const useHiddenInput = <T extends THiddenInput>(props: TInputProps<T>): TForm<THiddenInput> => {
    const form = useForm<THiddenInput>({
        id: "hidden",
        default: null,
        ...props,
    })

    useEffect(() => {
        form.update(form.value)
    }, [])

    return {
        ...form,
    }
};

export default useHiddenInput;
